require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./formalits-dimmigration-pour-tudiants-2-6-4.json") })
        }
      }, "path---formalits-dimmigration-pour-tudiants-2-6-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---formalits-dimmigration-pour-tudiants-2-6-4!./.cache/json/formalits-dimmigration-pour-tudiants-2-6-4.json
// module id = 436
// module chunks = 231608221292675